import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

export default function CanvaPortal({
  component: Component,
  props: componentProps = {},
  children
}) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const el = document.createElement("div");
    document.body.appendChild(el);
    setContainer(el);

    return () => {
      document.body.removeChild(el);
    };
  }, []);

  return (
    <>
      {children}
      {container && createPortal(<Component {...componentProps} />, container)}
    </>
  );
}
